import { ReactElement } from "react";
import { useTheme } from "styled-components";

export const Dots = (): ReactElement => {
  const theme = useTheme()
  
  return (
    <svg
      width="53"
      height="6"
      viewBox="0 0 53 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.72873 5.43181C1.97873 5.43181 1.33479 5.16666 0.796919 4.63636C0.266616 4.09848 0.00146484 3.45454 0.00146484 2.70454C0.00146484 1.96212 0.266616 1.32575 0.796919 0.795454C1.33479 0.265154 1.97873 0 2.72873 0C3.45601 0 4.09237 0.265154 4.63782 0.795454C5.18328 1.32575 5.45601 1.96212 5.45601 2.70454C5.45601 3.20454 5.32722 3.66288 5.06964 4.07954C4.81964 4.48863 4.4901 4.81818 4.08101 5.06818C3.67192 5.3106 3.22116 5.43181 2.72873 5.43181ZM26.5 5.43181C25.75 5.43181 25.1061 5.16666 24.5682 4.63636C24.0379 4.09848 23.7727 3.45454 23.7727 2.70454C23.7727 1.96212 24.0379 1.32575 24.5682 0.795454C25.1061 0.265154 25.75 0 26.5 0C27.2273 0 27.8637 0.265154 28.4091 0.795454C28.9546 1.32575 29.2273 1.96212 29.2273 2.70454C29.2273 3.20454 29.0985 3.66288 28.8409 4.07954C28.5909 4.48863 28.2614 4.81818 27.8523 5.06818C27.4432 5.3106 26.9924 5.43181 26.5 5.43181ZM50.2713 5.43181C49.5213 5.43181 48.8773 5.16666 48.3394 4.63636C47.8091 4.09848 47.544 3.45454 47.544 2.70454C47.544 1.96212 47.8091 1.32575 48.3394 0.795454C48.8773 0.265154 49.5213 0 50.2713 0C50.9985 0 51.6349 0.265154 52.1804 0.795454C52.7258 1.32575 52.9985 1.96212 52.9985 2.70454C52.9985 3.20454 52.8697 3.66288 52.6122 4.07954C52.3622 4.48863 52.0326 4.81818 51.6235 5.06818C51.2144 5.3106 50.7637 5.43181 50.2713 5.43181Z"
        fill={theme.colors.primary}
        fillOpacity="0.5"
      />
    </svg>
  );
};
